export default {
  current_action: '',
  accepted: false,
}
